import { useNavigate } from 'react-router-dom';
import { QuerySelect } from '../../QuerySelect';
import styles from './ApplicationSelect.module.css';
import { H6 } from '@blueprintjs/core';
import { ace_index, permissions } from '@axo/shared/data-access/types';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';
import { classNames } from '@axo/shared/util/dom';
import { useCustomerHistory } from '../../../hooks/queries/useCustomerHistory';
import { useHasAnyOfRoles } from '@axo/shared/data-access/provider';

interface IApplicationSelect {
  applicationID: string;
}

export function ApplicationSelect({ applicationID }: IApplicationSelect) {
  const application = useApplicationDetail(applicationID);
  const applicationsQuery = useCustomerHistory(
    {
      customerID: application.data?.CustomerID ?? '',
      marketCountry: application.data?.MarketCountry ?? '',
    },
    application.data !== undefined && !!application.data?.CustomerID.length,
  );
  const hasAccess = useHasAnyOfRoles([
    permissions.RoleName.Manager,
    permissions.RoleName.Sales,
    permissions.RoleName.SecuredSales,
    permissions.RoleName.Telemarketing,
  ]);
  const navigate = useNavigate();

  function onApplicationSelect(application: ace_index.LoanApplication) {
    navigate(`/application/${application.ID}`);
  }

  if (!applicationsQuery.data) return null;

  return (
    <div
      className={classNames(
        styles.container,
        applicationsQuery.data.Items.length > 1 ? styles.warning : '',
      )}
    >
      <H6>Customer Application:</H6>
      <QuerySelect<ace_index.LoanApplication>
        data={applicationsQuery.data.Items.sort((a, b) => {
          if (a.CreatedAt === b.CreatedAt) return 0;
          return a.CreatedAt > b.CreatedAt ? -1 : 1;
        })}
        onSelect={onApplicationSelect}
        stringify={(application) => application.HumanReadableID}
        value={applicationsQuery.data.Items.find(
          (application) => application.ID === applicationID,
        )}
        fill={true}
        className={styles.button}
        disabled={!hasAccess}
      />
    </div>
  );
}
